import { validateEmail } from 'services/validation/fieldValidator';

export default (values, { i18n }) => ({
  email: validateEmail(i18n, values.get('email')),
});
